import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
  selector: 'status-renderer',
  templateUrl: './status-renderer.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class StatusRenderComponent implements ICellRendererAngularComp {
  public text: string;
  public status: any;
  public ICONS = ICONS;
  public isBullet: boolean = true;

    private statusConfig = [
        { id: 1, type: 'primary' },
        { id: 2, type: 'success' },
        { id: 3, type: 'pending' },
        { id: 4, type: 'incomplete' },
        { id: 5, type: 'not-enabled' }
    ];
  constructor() { }

  initilize(params: ICellRendererParams) {
    this.status = params.getValue();
    if (this.status) {
      this.text =  this.statusConfig.find(item => item.id === this.status.statusType)?.type;
    }
    this.isBullet = params?.colDef?.headerComponentParams?.isBullet
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
